var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-icon',_vm._b({staticClass:"help",attrs:{"ios":"f7:question_circle","aurora":"f7:question_circle","md":"material:help_outline"}},'f7-icon',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }